import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function NasStorage() {
    return (
        <React.Fragment>
            <h4>Linux</h4>

            <p>
                During initial Linux installation, all SDCX Server services run as{' '}
                <code className="language-text">root</code>. If a distributed file system protocol, like NFS, is used
                with the root squashing feature enabled, a remote NFS client running as{' '}
                <code className="language-text">root</code> will be mapped to a non-root user ({' '}
                <code className="language-text">nfsnobody</code>).
            </p>

            <p>
                If a service running as <code className="language-text">root</code> in this scenario produces access
                errors when trying to read or write from a network share, configure the NFS server user permissions to
                match the root squashing user.
            </p>

            <h4>Windows</h4>

            <p>
                During initial Windows installation, all SDCX Server services run as{' '}
                <code className="language-text">NT-Authority\System</code>, which allows for unrestricted access to
                local system resources. Some SDCX Server services must be configured to run under a different account in
                order to access remote resources like NAS.
            </p>

            <p>To configure a username for shared storage on Windows:</p>
            <ol>
                <li> Open the Windows Services control panel.</li>
                <li>
                    {' '}
                    Select the <strong>Signiant Jet Server Service</strong>.
                </li>
                <li>
                    {' '}
                    Edit the service properties and click the <strong>Log On</strong> tab.
                </li>
                <li>
                    {' '}
                    Select <strong>This account</strong>.
                </li>
                <li>
                    {' '}
                    Enter the domain, username and password to access network storage. This user requires local
                    administrator privilege on the local machine. (e.g.{' '}
                    <code className="language-text">domain\userName</code>)
                </li>

                <p>
                    <strong>Note</strong>: The NAS server itself may be on a Windows domain. If the server is not
                    associated with a Windows domain, do not enter a domain.
                </p>
                <li>
                    {' '}
                    Click <strong>OK</strong> to save the configuration changes.
                </li>
                <li> Restart the service to apply the changes.</li>
                <li>
                    {' '}
                    Repeat steps 1-7 for the <strong>Signiant Media Shuttle Web Server</strong> service and the{' '}
                    <strong>Media Shuttle Process Controller</strong> service using the same credentials as the Signiant
                    Jet Server service.
                </li>
                <li>
                    {' '}
                    Configure endpoints to use your shared storage by specifying a UNC path. (e.g.{' '}
                    <code className="language-text">\\server\share\jet-source</code>)
                </li>
            </ol>
        </React.Fragment>
    );
}

NasStorage.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NasStorage);
